import React from 'react'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

type Breakpoints = 'xs' | 'sm' | 'md' | 'lg'

interface SearchResultsSkeletonSegmentProps {
  height: number
  width: number
  borderRadius?: string | Partial<Record<Breakpoints, number | string>>
  mb?: number | Partial<Record<Breakpoints, number>>
}

const SearchResultsSkeletonSegment: React.FC<
  SearchResultsSkeletonSegmentProps
> = ({ height, width }) => {
  const theme = useTheme()

  return (
    <Box
      height={height}
      width={width}
      borderRadius="1px"
      bgcolor={theme.palette.grey['50']}
      mb={10}
    />
  )
}

export default SearchResultsSkeletonSegment
